import React, {Component} from "react";
import Table from "../../../components/Table";
import ShopItem from "./ShopItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_SHOPS} from "../../../queries/sales";

class ShopsList extends Component {

  render() {
    let {loading, error, shops} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "Jurisdiction",
      "Title",
      "Currencies"
    ])
    return (
      <Table 
        data={fromJS(shops)} 
        renderer={ShopItem} 
        tableHeader={tableHeader}
        onItemClick={this.handleItemClick.bind(this)}
        selected={this.props.selectedId}
        mode="table"
        itemKey="shopId"
        />
    )
  }

  handleItemClick(itemData, e, field) {
    let id = itemData.get("shopId");
    if (field === "shopId") {
      e.stopPropagation();
      this.props.onShopIdClick(id);
      return;
    }
    this.props.onSelectionChange(id, itemData.get("shopId"));
  }  
}

const withQuery = graphql(LIST_SHOPS, {
  options: (props) => ({
    fetchPolicy: "network-only"
  })
})

export default withQuery(ShopsList);